import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'

import SingleUser from './Single';
import Loader from "../../components/Loader";
import Table from "./Table";

const Agent = props => {
  const { user } = props;
  const [isSingle, setIsSingle] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [path, setPath] = useState("");
  // console.log('props on company', props);

  useEffect(() => {
    if (props.location) {
      console.log('path on opportunities', props.location.pathname.split("/"));
      const path = props.location.pathname;
      if (path.split("/").length > 1) {
        const role = path.split("/")[2];
        if (role) {
          setPath(role);
        }
      }
    }
  }, [props]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Users" />
        {isSingle ?
          <Card>
            <CardBody>
              <SingleUser
                user={user}
                setLoading={setLoading}
                close={setIsSingle}
                history={props.history}
                currentUser={currentUser}
              />
            </CardBody>
          </Card>
          :
          <Card>
            <CardBody>
              <Table
                role={"Users"}
                path={path}
                user={props?.user}
                view={setIsSingle}
                setLoading={setLoading}
                currentData={currentUser}
                setCurrentData={setCurrentUser}
                getProfile={props?.getProfile}
                updateCompany={props?.updateCompany}
                history={props.history}
              />
            </CardBody>
          </Card>
        }
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, {})(Agent)
)
